import { render, staticRenderFns } from "./DynamicLink.vue?vue&type=template&id=46eb0ac9&"
import script from "./DynamicLink.vue?vue&type=script&lang=js&"
export * from "./DynamicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports